import { useSelector } from 'react-redux'
import {
  selectCurrentUser,
  useGetSalesTeamPositionsData,
} from '@user/store/authorization'
import {
  salesTeamsForCurrentUser,
  useGetSalesTeamListOnMount,
} from '@user/store/salesTeam'
import { useGetUserById } from '@user/store/users/hooks/useGetUserById'

export function useData() {
  const positionStatus = useGetSalesTeamPositionsData()
  const cUser = useSelector(selectCurrentUser)

  const teamStatus = useGetSalesTeamListOnMount()

  const { status: userStatus, user: currentUser } = useGetUserById(cUser.userId)

  const salesTeamsForUser = useSelector(salesTeamsForCurrentUser)

  const loading =
    positionStatus === 'pending' ||
    teamStatus === 'pending' ||
    userStatus === 'pending'

  const failed =
    positionStatus === 'fail' || teamStatus === 'fail' || userStatus === 'fail'

  const success =
    positionStatus === 'success' ||
    teamStatus === 'success' ||
    userStatus === 'success'

  return {
    loading,
    failed,
    success,
    currentUser,
    salesTeamsForUser,
  }
}
